import serverInterface from 'server-interface';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import externalEventCodes from 'event-system/codes/external';

class FavouritePageNodesManager {

  constructor(application) {

    this.initialized = false;
    this.loaded = false;
    this.favouritePageNodes = [];
    this.publicFavouritePageNodes = [];

    this.application = application;

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.initialized = true;

  }

  tryAddFavouritePageNode(favouritePageNode) {

    if (favouritePageNode.public === true) {
      return;
    }

    const favouritePageNodeIndex = findIndexByPropertyValue(this.favouritePageNodes, '_id', favouritePageNode._id);

    if (favouritePageNodeIndex !== -1) {
      return;
    }

    this.favouritePageNodes.push(favouritePageNode);

  }

  tryAddPublicFavouritePageNode(favouritePageNode) {

    if (favouritePageNode.public === false) {
      return;
    }

    const favouritePageNodeIndex = findIndexByPropertyValue(this.publicFavouritePageNodes, '_id', favouritePageNode._id);

    if (favouritePageNodeIndex !== -1) {
      return;
    }

    this.publicFavouritePageNodes.push(favouritePageNode);

  }

  tryRemoveFavouritePageNode(favouritePageNodeId) {

    const favouritePageNodeIndex = findIndexByPropertyValue(this.favouritePageNodes, '_id', favouritePageNodeId);

    if (favouritePageNodeIndex === -1) {
      return;
    }

    this.favouritePageNodes.splice(favouritePageNodeIndex, 1);

  }

  tryRemovePublicFavouritePageNode(favouritePageNodeId) {

    const favouritePageNodeIndex = findIndexByPropertyValue(this.publicFavouritePageNodes, '_id', favouritePageNodeId);

    if (favouritePageNodeIndex === -1) {
      return;
    }

    this.publicFavouritePageNodes.splice(favouritePageNodeIndex, 1);

  }

  tryRemove(favouritePageNodeId) {

    this.tryRemoveFavouritePageNode(favouritePageNodeId);

  }

  handleFavouritePageNodeCreatedEvent(payload) {

    this.tryAddFavouritePageNode(payload.favouritePageNode);
    this.tryAddPublicFavouritePageNode(payload.favouritePageNode);

  }

  handleFavouritePageNodeDeletedEvent(payload) {

    this.tryRemoveFavouritePageNode(payload.favouritePageNodeId);
    this.tryRemovePublicFavouritePageNode(payload.favouritePageNodeId);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.FAVOURITE_PAGE_NODE_CREATED, this.handleFavouritePageNodeCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.FAVOURITE_PAGE_NODE_DELETED, this.handleFavouritePageNodeDeletedEvent.bind(this));

  }

  async loadAll() {

    if (this.loaded === true) {
      return;
    }

    this.favouritePageNodes = await serverInterface.startup.users.favouritePageNodes.getAllPrivateFavouritePageNodes();
    this.publicFavouritePageNodes = await serverInterface.startup.users.favouritePageNodes.getAllPublicFavouritePageNodes();
    this.loaded = true;
  }

  getAll() {

    return this.favouritePageNodes;

  }

  getAllPublicNodes() {

    return this.publicFavouritePageNodes;

  }

  isFavouritePageNodeExistsById(favouritePageNodeId) {

    const favouritePageNodeIndex = findIndexByPropertyValue(this.favouritePageNodes, '_id', favouritePageNodeId);

    return favouritePageNodeIndex !== -1;

  }

  getNodeById(favouritePageNodeId) {

    return [
      ...this.getAll(),
      ...this.getAllPublicNodes()
    ].find(function finder(node) {
      return node._id === favouritePageNodeId;
    });

  }

  async create(data) {

    const favouritePageNode = await serverInterface.startup.users.favouritePageNodes.createFavouritePageNode(data);

    this.tryAddFavouritePageNode(favouritePageNode);
    this.tryAddPublicFavouritePageNode(favouritePageNode);

    return favouritePageNode;

  }

  async delete(favouritePageNodeId) {

    await serverInterface.startup.users.favouritePageNodes.deleteFavouritePageNodeById(favouritePageNodeId);

    this.tryRemoveFavouritePageNode(favouritePageNodeId);
    this.tryRemovePublicFavouritePageNode(favouritePageNodeId);

  }

  async unpublic(favouritePageNodeId) {

    await serverInterface.startup.users.favouritePageNodes.unpublicFavouritePageNodeById(favouritePageNodeId);

    this.tryRemoveFavouritePageNode(favouritePageNodeId);
    this.tryRemovePublicFavouritePageNode(favouritePageNodeId);

  }

}

export default FavouritePageNodesManager;